<div class="slds-form-element">
  <label class="slds-form-element__label" for="example-unique-id-33" id="combobox-label-id-14">Time</label>
  <div class="slds-form-element__control">
    <div class="slds-combobox_container">
      <div
        #sdlsCombobox
        class="slds-combobox slds-dropdown-trigger slds-dropdown-trigger_click slds-timepicker"
        [ngClass]="{ 'slds-is-open': isOpen }"
      >
        <div class="slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right" role="none">
          <ngl-input [label]="to.label || ''">
            <input
              ngl
              (click)="open()"
              [name]="key"
              type="text"
              [formControl]="$any(formControl)"
              [required]="to.required || false"
              [placeholder]="to.placeholder"
              class="slds-input slds-combobox__input"
              role="combobox"
              aria-activedescendant=""
              aria-autocomplete="list"
              aria-controls="example-unique-id-34"
              aria-expanded="true"
              aria-haspopup="listbox"
              [autocomplete]="to.attributes?.['autocomplete'] || 'nope'"
            />
            <span class="slds-icon_container slds-icon-utility-clock slds-input__icon slds-input__icon_right">
              <svg class="slds-icon slds-icon slds-icon_x-small slds-icon-text-default" aria-hidden="true">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#clock"></use>
              </svg>
            </span>
          </ngl-input>
        </div>
        <div id="example-unique-id-34" class="slds-dropdown slds-dropdown_length-5 slds-dropdown_fluid" role="listbox">
          <ul class="slds-listbox slds-listbox_vertical" role="presentation">
            <li *ngFor="let time of times" role="presentation" class="slds-listbox__item">
              <div
                (click)="setValue(time)"
                id="option1"
                class="slds-media slds-listbox__option slds-listbox__option_plain slds-media_small"
                role="option"
              >
                <span class="slds-media__figure slds-listbox__option-icon"></span>
                <span class="slds-media__body">
                  <span class="slds-truncate" title="{{ time }}">{{ time }}</span>
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
